<template>
    <div class="w-full">
        <div class="analysis gap-2">
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('goldenFlower.room') }}
                </h6>
                <em class="quantity"> {{ locale === 'cn' ? history.hallNameCn :history.hallName}} </em>
            </div>
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('Bet') }}
                </h6>
                <em class="quantity">
                    <CurrentCoin :name="history.currency" />
                    {{ getFixed(history.amount) }}
                </em>
            </div>
            <div class="gray-box min-w-full">
                <h6 class="title">
                    {{ $t('goldenFlower.Profit') }}
                </h6>
                <em class="quantity" :class="history.diff > 0 ? 'won' : 'lose'">
                    <CurrentCoin :name="history.currency" />
                    <Popper :style="oPopperStyle" :hover="true" :arrow="true" placement="top">
                        <span>{{ Number(history.diff).toFixed(2) }}</span>
                        <template #content>
                            <div class="popper-content">
                                <CurrentCoin class="inline-flex" :name="history.currency" />
                                {{ getFixed(history.diff, 4) }}
                            </div>
                        </template>
                    </Popper>
                </em>
            </div>
        </div>
        <div class="big-list gray-box">
            <q-table :pagination="{ rowsPerPage: 100 }" hide-pagination row-key="name"
                :no-data-label="$t('Noinformation')" :rows="tableArr" :columns="oActiveTable.aColumns"
                table-class="big-table">
                <template v-slot:body="props">
                    <q-tr :props="props">
                        <q-td class="td-user" key="date">
                            <div class="td-inner" :data-t01="JSON.stringify(props)">
                                <span class="text">
                                    <span class="truncate">
                                        {{ props.row.userName }}
                                    </span>
                                    <time class="truncate" :class="winOrLoseMap[props.row.winOrLose]">
                                        <template v-if="props.row.winOrLose === 1">
                                            {{ $t('goldenFlower.winText') }}
                                        </template>
                                        <template v-else-if="props.row.winOrLose === 2">
                                            {{ $t('goldenFlower.loseText') }}
                                        </template>
                                        <template v-else>
                                            {{ $t('goldenFlower.drawText') }}
                                        </template>
                                    </time>
                                </span>
                            </div>
                        </q-td>
                        <q-td key="cardsInfo">
                            <div class="py-2 flex items-center flex-nowrap">
                                <template v-if="props.row.cards.length">
                                    <PokerCard v-for="it in (props.row.cards)" :cardName="it.suit + it.rank" real />
                                </template>
                                <template v-else>
                                    <PokerCard v-for="i01 in 3" :key="i01" real />
                                </template>
                            </div>
                        </q-td>
                        <q-td class="td-profit" key="amountInUsd">
                            <div v-if="props.row.cardType !== -1" class="text-white">
                                {{ $t(`goldenFlower.rule02_column01${typeList[props.row.cardType]}`) }}</div>
                            <div class="td-inner">
                                <CurrentCoin size="18px" class="" :name="history.currency" />
                                <span class="text" :class="{
                                        won: props.row.diff > 0,
                                        loose: props.row.diff < 0,
                                    }">
                                    <Popper :style="oPopperStyle" :hover="true" :arrow="true" placement="top">
                                        <CasinoWidgetColoredAmount class="font-semibold" :colors="['', '']"
                                            :amount="Number(props.row.diff)">
                                        </CasinoWidgetColoredAmount>
                                        <template #content>
                                            <div class="popper-content">
                                                <CurrentCoin size="18px" class="inline-flex" :name="history.currency" />
                                                {{ getFixed(props.row.diff, 4) }}
                                            </div>
                                        </template>
                                    </Popper>
                                </span>
                            </div>
                        </q-td>
                    </q-tr>
                </template>
                <template v-slot:no-data="{ message }">
                    <img class="no-data-pic" src="@/assets/imgs/no-data.webp" />
                    <p class="no-data-message">
                        {{ message }}
                    </p>
                </template>
            </q-table>
        </div>
    </div>
</template>

<script setup lang="ts">
import Popper from 'vue3-popper';
import PokerCard from '~/pages/casino/zhajinhuaGame/_components/pokerCard.vue';

const props = defineProps({
    modelValue: Boolean, //
    backdrop: {
        type: Boolean,
        default: true,
    },
    history: {
        type: Object,
        default: () => ({}),
    },
});
const { t: $tFn, locale } = useNuxtApp().$i18n;
const obj01 = { field: '', name: '', label: '' };
const oActiveTable = reactive({
    aColumns: [{ ...obj01, label: $tFn('goldenFlower.result') }, obj01, obj01],
});
const typeList = ['G', 'F', 'E', 'D', 'C', 'B'];

const winOrLoseMap = {
  1: 'won',
  2: 'lose',
  3: 'draw'
}
// 主表数据
const tableArr = computed(() => {
    const arr = props.history['cardsInfo'] || [];
    return arr;
});
</script>

<style lang="scss" scoped>
.gray-box {
    // background: rgba(32, 42, 57, 1);
    background-color: #161f2c; // 与窗口其它元素颜色一致
    padding: 12px;
    border-radius: 8px;
}

.analysis {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    // align-items: center;
    flex-wrap: wrap;
    flex-direction: row;

    & > * {
        min-height: 55px; // 与临近元素等高
        padding-top: 10px;
        padding-bottom: 10px;
        flex: 1 1 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .title {
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: rgba(147, 172, 211, 1);
        margin: 0 0 5px;
    }
    .quantity {
        color: white;
        font-weight: 500;
        font-size: 16px;
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin: 0 6px 0 -3px;
        }
    }
}

.won {
    color: rgba(27, 184, 61, 1) !important;
}
.lose {
    color:  #A7B5CA;
}
.big-list {
    & > .q-table__card {
        background-color: transparent;
        box-shadow: none;
    }
    & :deep(table.q-table) {
        width: 100%;
        overflow: hidden;
        background-color: transparent;
        tr {
            // border-bottom: 0.5px solid var(--bet-corgi-color-white-12, rgba(255, 255, 255, 0.12))
            border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        }
        body tr:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
        th {
            color: rgba(85, 101, 126, 1);
            font-size: 12px;
            text-align: left;
        }
        td {
            opacity: 1;
        }
        th,
        td {
            padding-left: 4px;
            padding-right: 4px;
        }
    }
    td {
        .td-inner {
            font-size: 14px;
            line-height: 14px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            overflow: hidden;
            max-width: 99%;
            padding: 5px 0;
            .user-avatar,
            img {
                margin: 0 5px 0 0;
            }
            .text {
                min-width: 10px;
            }
        }
        // ↓ 触雷后支付的金额
        .loose {
            color: #A7B5CA;
        }
    }
    .td-user {
        color: white;
        font-weight: 600;
        .text {
            font-size: 12px;
            & > * {
                display: block;
            }
            time {
                font-size: 11px;
                color: rgba(167, 181, 202, 1);
            }
        }
    }
    .td-profit {
        font-weight: 600;
        color: rgba(147, 172, 211, 1);
    }
}
.no-data-message {
    min-height: 150px;
    width: 100%;
    padding: 20px;
    text-align: center;
    .no-data-pic {
        width: 165px;
        margin: 0 auto 0;
    }
    .no-data-tips {
        font-size: 14px;
        color: rgba(167, 181, 202, 1);
    }
}
</style>
